import React from 'react';

export default function Loading(props: { message?: string }) {
	const { message } = props;
	return (
		<div className="loading">
			<div className="lds-ring">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
			{message && <span>{message}</span>}
		</div>
	);
}
